import { ChangeDetectorRef, Directive, Input, OnChanges, Self } from '@angular/core';
import { CallState, LoadingState } from '@lcs/shared/api';
import { LcsProgressButtonComponent, LcsProgressButtonStatus } from '@lcs/shared/progress-button';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[useCallState]',
    standalone: false
})
export class CallStateDirective implements OnChanges {
   @Input('useCallState') callState: Observable<CallState>;

   private callStateSubscription: Subscription;

   private destroyed = new Subject<void>();

   constructor(@Self() private button: LcsProgressButtonComponent, private changeDetectorRef: ChangeDetectorRef) {}

   ngOnChanges(): void {
      if (this.callStateSubscription) {
         this.callStateSubscription.unsubscribe();
      }
      if (this.callState) {
         this.callStateSubscription = this.callState.pipe(takeUntil(this.destroyed)).subscribe((callState) => {
            switch (callState) {
               case LoadingState.Loading:
                  this.updateStatus(LcsProgressButtonStatus.InProgress);
                  break;
               case LoadingState.Loaded:
                  this.updateStatus(LcsProgressButtonStatus.Success);
                  break;
               case LoadingState.Init:
                  this.updateStatus(LcsProgressButtonStatus.Unset);
                  break;
               default:
                  this.updateStatus(LcsProgressButtonStatus.Error);
                  break;
            }
         });
      }
   }

   private updateStatus(status: LcsProgressButtonStatus): void {
      this.button.status = status;
      this.changeDetectorRef.markForCheck();
   }
}
